<div>
  <input type="text" class="form-control" [(ngModel)]="email" />
  <button class="btn-primary" type="button" (click)="validateTestEval()">Validate</button>

  <span>{{validationResonse}}</span>
</div>
